import { render, staticRenderFns } from "./warehouseInbound.vue?vue&type=template&id=fc2c2236&scoped=true"
import script from "./warehouseInbound.vue?vue&type=script&lang=js"
export * from "./warehouseInbound.vue?vue&type=script&lang=js"
import style0 from "./warehouseInbound.vue?vue&type=style&index=0&id=fc2c2236&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc2c2236",
  null
  
)

export default component.exports